import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "GOVHH_ABS_REL",
  title: defineMessage({
    id: "fig.finance.GOVHH_ABS_REL.title",
    defaultMessage: `Shares of governments and households in education spending`,
  }),
  caption: defineMessage({
    id: "fig.finance.GOVHH_ABS_REL.caption",
    defaultMessage: `In many low and middle income countries, households contribute between one fifth and half of all education spending.`,
  }),
  source: defineMessage({
    id: "fig.finance.GOVHH_ABS_REL.source",
    defaultMessage: `UIS database`,
  }),
};
